import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Solution } from '../../models/Solution';

interface SolutionState {
  solution: Solution | null;
  loading: boolean;
  error: string | null;
}

const initialState: SolutionState = {
  solution: null,
  loading: false,
  error: null,
};

const solutionSlice = createSlice({
  name: 'solution',
  initialState,
  reducers: {
    setSolution: (state, action: PayloadAction<Solution>) => {
      state.solution = action.payload;
    },
    clearSolution: state => {
      state.solution = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setSolution, clearSolution, setLoading, setError } = solutionSlice.actions;
export default solutionSlice.reducer;
